module.exports = __webpack_public_path__ + "static/media/sa6.2273ee81.jpg";